<template>
  <div>
    <v-row dense class="mt-2">
      <v-col cols="12" md="6">
        <setting-card
          v-model="formData.showEventsInOthers"
          icon="mdi-tray-arrow-up"
          title="Mostrar em outras"
          description="Permite que os eventos dessa plataforma sejam divulgados em outras plataformas que aceitem."
        />
      </v-col>

      <v-col cols="12" md="6">
        <setting-card
          v-model="formData.showEventsFromOthers"
          icon="mdi-tray-arrow-down"
          title="Mostrar de outras"
          description="Permite que os eventos de outras plataformas sejam divulgados nessa plataforma."
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SettingCard from "@/components/global/SettingCard.vue";

export default {
  name: "PartyShareStep",
  components: {
    SettingCard,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    oldValue: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    hasChanges() {
      if (this.oldValue.showEventsInOthers !== this.formData.showEventsInOthers)
        return true;
      if (
        this.oldValue.showEventsFromOthers !==
        this.formData.showEventsFromOthers
      )
        return true;

      return false;
    },
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    getFormData() {
      if (!this.hasChanges) return false;
      return {
        showEventsInOthers: !!this.formData.showEventsInOthers,
        showEventsFromOthers: !!this.formData.showEventsFromOthers,
      };
    },
  },
};
</script>
